import { createDataSelectors } from "@app/modules/app.reducers";
import { Token } from "@ea/shared_types/types";

export const apiKeyDataSelectors = createDataSelectors<Token>()("apiKey");
